var map = {
	"./feature_buy_en.png": 97847,
	"./feature_buy_id.png": 77921,
	"./feature_buy_my.png": 61936,
	"./feature_buy_ph.png": 73946,
	"./feature_buy_th.png": 4742,
	"./feature_buy_zh.png": 31992
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90761;